import React from 'react';
import { FormattedMessage } from 'react-intl';

import { H2 } from '../Heading/Heading';
import OrderListing from '../OrderListing/OrderListing';
import Accordion from '../Accordion/Accordion';

import css from './OrderSummary.module.css';

const OrderSummary = ({ className, listings, children }) => {
  const renderListing = listing => (
    <OrderListing key={listing.id.uuid} listing={listing} className={css.listing} showAuthorInfo />
  );

  return (
    <div className={className}>
      <H2 className={css.heading}>
        <FormattedMessage id="OrderSummary.title" />
      </H2>
      {listings?.length === 1 && listings.map(renderListing)}
      {listings?.length > 1 && (
        <Accordion
          panelClassName={css.listingsPanel}
          panelLabelClassName={css.listingPanelLabel}
          panelContentClassName={css.listingPanelContent}
          panels={[
            {
              id: 'listings',
              label: <FormattedMessage id="OrderSummary.listings" />,
              content: listings.map(renderListing),
            },
          ]}
        />
      )}
      {children}
    </div>
  );
};

export default OrderSummary;
